<template>
  <div class="footer-wrapper" :class="{'footer-wrapper--videoresume': isVideoresume}">
    <div class="footer" :class="{
        'is-landing': type === 'landing',
        'is-adaptive': is_adaptive,
        'public-response': public_response
      }">
      <div class="footer-copyright">
        <span class="copyright footer-group">{{ $tr('copyright_landing', {
          year: this.year
        }) }}</span>

        <a :href="'mailto:' + support.text" target="_blank" rel="noopener">{{support.text}}</a>
      </div>
      <div class="footer-logo">
        <a class="footer-link" target="_blank" rel="noopener" :href="`https://${this.domain}/`">
          <span>Made on</span>
          <svg width="35" height="11" viewBox="0 0 35 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.694 0.503924C9.8038 0.0753385 8.70116 0.391233 8.23432 1.21432C8.23432 1.21432 7.37923 2.72236 6.8473 3.65683C6.51748 4.23709 6.35046 4.90214 6.26958 5.32274H6.14362C6.06642 4.9116 5.90309 4.26334 5.55958 3.65797C5.00169 2.67506 4.17414 1.21432 4.17414 1.21432C3.70624 0.391233 2.60449 0.0746862 1.71343 0.503924C0.821504 0.934466 0.475889 1.94967 0.942556 2.7708L4.5873 9.19599C4.90361 9.75096 5.5266 10.098 6.20414 10.098C6.88344 10.098 7.5045 9.75096 7.81871 9.19599L11.4657 2.77145C11.9317 1.94967 11.5877 0.934303 10.694 0.503924Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0886 0.503924C32.1971 0.0753385 31.096 0.391233 30.6295 1.21432C30.6295 1.21432 29.7728 2.72236 29.2442 3.65683C28.9141 4.23709 28.7451 4.90214 28.6644 5.32274H28.5388C28.4616 4.9116 28.2988 4.26334 27.9534 3.65797C27.3976 2.67506 26.5681 1.21432 26.5681 1.21432C26.1007 0.391233 25.0004 0.0746862 24.1077 0.503924C23.2151 0.934466 22.8704 1.94967 23.3369 2.7708L26.9827 9.19599C27.2986 9.75096 27.9197 10.098 28.5986 10.098C29.2762 10.098 29.8999 9.75096 30.2144 9.19599L33.8595 2.77145C34.3267 1.94967 33.9821 0.934303 33.0886 0.503924Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6387 10.3125C14.6724 10.3125 12.2589 8.06944 12.2589 5.31217C12.2589 2.5554 14.6724 0.3125 17.6389 0.3125C19.1645 0.3125 20.5356 0.922761 21.4489 1.78075C22.0742 2.34486 22.0909 3.35761 21.4321 3.96999C21.1159 4.26371 20.6963 4.42565 20.2496 4.42565C19.8309 4.42565 19.4268 4.364 19.0724 3.9757C18.6898 3.56277 18.1763 3.3139 17.6387 3.3139C16.5728 3.31504 15.7056 4.21136 15.7056 5.31217C15.7056 6.41332 16.5728 7.30914 17.6387 7.30914C18.1968 7.30914 18.693 7.073 19.0742 6.64506C19.403 6.29166 19.8235 6.17864 20.2702 6.17864C20.717 6.17864 21.1366 6.34042 21.4521 6.63413C22.0984 7.23559 22.1087 8.22796 21.4493 8.84099C20.4309 9.7877 19.0794 10.3125 17.6387 10.3125Z" fill="currentColor"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex'

  export default {
    name: 'vfooterLanding',
    props: {
      type: {
        type: String,
        default: 'main'
      },
      company_language: {
        default: null
      },
      isVideoresume: {
        default: false
      }
    },
    data() {
      return {
        year: new Date().getFullYear()
      }
    },
    computed: {
      ...mapState(['locale']),
      lang() {
        if (!this.company_language) {
          return this.locale.value;
        }
        return this.company_language.toLowerCase();
      },
      domain () {
        switch (this.lang) {
          case 'ru':
            return 'vcv.ru'
          default:
            return 'vcv.ai'
        }
      },
      privacy_link() {
        if (!this.company_language) {
          return `https://${this.domain}/pages/privacy-policy`;
        }

        switch (this.lang) {
          case 'ru':
            return `https://vcv.ru/pages/privacy-policy`;
          case 'ja':
          case 'jp':
            return 'https://content.vcv.co.jp/privacy_policy';
          default:
            return `https://vcv.ai/pages/privacy-policy`;
        }
      },
      support () {
        return {
          text: this.domain === 'vcv.ru' ? `support@${this.domain}` : `ask@${this.domain}`
        };
      },
      phone_link () {
        return this.$tr('common.en.phone', 'en')
      },
      showPrivacyPolicy () {
        return this.type === 'landing'
      },
      userAgreement () {
        return this.type === 'landing' && this.lang === 'ru'
      },
      showSupport () {
        return this.type === 'landing'
      },
      is_adaptive () {
        return this.$route.meta ? this.$route.meta.is_adaptive : null
      },
      public_response () {
        return this.$route.meta ? this.$route.meta.public_response : null
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';
@import '@/styles/variables.scss';

.footer-wrapper {
  position: relative;
  background-color: #333;
  min-height: 60px;
  box-sizing: border-box;
  padding: 12px 0;
  margin-top: auto;
  margin-bottom: 0;
  display: flex;
  justify-content: center;

  &.footer-wrapper--videoresume {
    background-color: #555;
  }
  .footer {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    position: relative;

    @include tablet {
      max-width: 920px;
      padding-left: 20px;
      padding-right: 20px;
      flex-direction: column;
      align-items: flex-start;

      .footer-copyright {
        position: relative;
        top: 0;
        left: 0;
      }
    }

    &:not(.is-landing):not(.is-adaptive):not(.public-response) {
      @include desktop {
        padding-left: 20px;
        padding-right: 20px;
        max-width: 100%;
        width: 1240px;
        box-sizing: border-box;
      }

      @include tablet {
        max-width: 100%;
        width: 1240px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
      }

      @include mobile {
        max-width: 100%;
        width: 1240px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
      }
    }

    .copyright {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #9b9b9b;
    }

    > div {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .footer-group {
      display: inline-block;
      margin: 5px 20px 5px 0;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #9b9b9b;

      &:last-child {
        margin-right: 28px;
      }
    }
    .link {
      white-space: nowrap;
    }

    .logo-icon {
      width: 24px;
    }
  }
}

.footer-copyright {
  position: absolute;
  top: 3px;
  left: 24px;
  display: flex;
  align-items: center;

  span {
    margin-right: 16px;
  }

  a {
    color: #9b9b9b;
    transition: color ease-in-out 0.3s;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    &:hover {
      color: $green-hover;
    }
  }
}

.footer-link {
  display: flex;
  align-items: center;
  color: #9b9b9b;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  span {
    margin-right: 3px;
  }

  &:hover {
    color: #fff;
    transition: all ease-in-out 0.3s;

    svg,
    path {
      color: $green;
    }
  }
}
</style>
